import {DrupalDocumentMedia, DrupalSearchApiResponseMeta, FacetFilters} from "types/hygiena-types";
import {DrupalJsonApiParams} from "drupal-jsonapi-params";

interface DocumentData {
  documents?: DrupalDocumentMedia[],
  meta?: DrupalSearchApiResponseMeta,
}

export interface Filter {
  path: string,
  value: string,
  operator: string,
}

/**
 * Searches the document library.
 *
 * @param filters
 *   Filters to apply.
 * @param pageLimit
 *   The page limit.
 * @param pageOffset
 *   The current page offset.
 * @param preFilters
 *   Additional prefilters.
 * @param locale
 *   The current locale i.e. en.
 * @param defaultLocale
 *   The default locale i.e. en.
 */
export async function documentSearch(filters: FacetFilters, pageLimit: number, pageOffset: number, preFilters: Filter[], locale?: string, defaultLocale?: string) {
  let ok = true;
  let data = {} as DocumentData;

  try {
    const params = new DrupalJsonApiParams()
      .addInclude([
        "field_document_categories",
        "field_document_language",
        "field_document_region",
        "field_document_industry",
        "field_media_file",
      ])
      .addFilter("status", "1")
      .addFilter("mid", "0", ">")
      .addPageLimit(pageLimit)
      .addPageOffset(pageOffset)
      .addSort("field_document_categories_weight", "ASC")
      .addSort("name", "ASC")
      .addSort("created", "DESC");
      // Cache bust.
      params.addCustomParam({'timeStamp': new Date().getTime().toString()});

    // Prefilter in the instance of forcing a specific category etc.
    for (const preFilter of preFilters) {
      params.addFilter(preFilter.path, preFilter.value, preFilter.operator);
    }

    for (const key of Object.keys(filters)) {
      if (key === 'document_search') {
        params.addFilter('fulltext', filters[key]);
      }
      else {
        params.addFilter(key, filters[key]);
      }
    }

    // Add the locale prefix if not en.
    const res = await fetch(`/api/search/document`, {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        "Cache-Control": "no-cache",
        "Pragma": "no-cache",
        "Expires": "0"
      },
      body: JSON.stringify({
        locale,
        params: params.getQueryObject(),
      }),
      cache: "no-store",
    });

    const json = await res.json();
    data.documents = json?.documents ?? [];
    data.meta = json?.meta;
  }
  catch (error) {
    ok = false;
    console.log(error.message);
  }

  return {ok, data};
}
